import { memo, useState, useEffect } from "react"
import { useTranslation } from "react-i18next";
import { LIST_CFD_SYMBOL, LIST_FX_SYMBOL, SymbolType } from "../models/constants";
import Symbol from "../components/symbol";
import useDetectMobile from "../hooks/useDetectMobile";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";

const MarketWatch = () => {
    const { t } = useTranslation();
    const isMobile = useDetectMobile();
    const quote = useSelector((state: RootState) => state.quote["USDJPY.ps01"]);

    const renderHeader = (symbolType: number) => {
        return (
            <>
                {isMobile &&
                    <thead>
                        <tr>
                            <th className="pe-0 d-none d-md-table-cell" style={{ "width": "60px" }}>&nbsp;</th>
                            {symbolType === SymbolType.FX && <th className="ps-md-0"><span className="text-ellipsis">通貨ペア</span></th>}
                            {symbolType === SymbolType.CFD && <th className="ps-md-0"><span className="text-ellipsis">銘 柄</span></th>}
                            <th style={{ "width": "120px" }} className="text-end"><span className="text-ellipsis">BID（売値）</span><span className="text-ellipsis d-block d-md-none">ASK（買値）</span></th>
                            <th className="text-center">&nbsp;</th>
                            <th style={{ "width": "120px" }} className="text-end d-none d-md-table-cell"><span className="text-ellipsis">ASK（買値）</span></th>
                            <th className="text-center d-none d-md-table-cell">&nbsp;</th>
                            <th className="text-end">
                                <span className="text-ellipsis">スプレッド</span>
                                {/* <span className="text-ellipsis d-block d-md-none">前日比</span> */}
                            </th>
                            {/* <th className="text-end d-none d-md-table-cell"><span className="text-ellipsis">前日比</span></th>
                            <th className="text-end"><span className="text-ellipsis">HIGH</span><span className="text-ellipsis d-block d-md-none">LOW</span></th>
                            <th className="text-end d-none d-md-table-cell"><span className="text-ellipsis">LOW</span></th> */}
                        </tr>
                    </thead>
                }
                {!isMobile &&
                    <thead>
                        <tr>
                            <th className="pe-0 d-none d-md-table-cell" style={{ "width": "10%" }}>&nbsp;</th>
                            {symbolType === SymbolType.FX && <th className="ps-md-0" style={{ "width": "20%" }}><span className="text-ellipsis">通貨ペア</span></th>}
                            {symbolType === SymbolType.CFD && <th className="ps-md-0" style={{ "width": "20%" }}><span className="text-ellipsis">銘 柄</span></th>}
                            <th style={{ "width": "20%" }} className="text-end"><span className="text-ellipsis">BID（売値）</span><span className="text-ellipsis d-block d-md-none">ASK（買値）</span></th>
                            <th className="text-center" style={{ "width": "5%" }}>&nbsp;</th>
                            <th style={{ "width": "20%" }} className="text-end d-none d-md-table-cell"><span className="text-ellipsis">ASK（買値）</span></th>
                            <th className="text-center d-none d-md-table-cell" style={{ "width": "5%" }}>&nbsp;</th>
                            <th className="text-end" style={{ "width": "20%" }}>
                                <span className="text-ellipsis">スプレッド</span>
                                {/* <span className="text-ellipsis d-block d-md-none">前日比</span> */}
                            </th>
                            {/* <th className="text-end d-none d-md-table-cell" style={{ "width": "8%" }}><span className="text-ellipsis">前日比</span></th>
                            <th className="text-end" style={{ "width": "10%" }}><span className="text-ellipsis">HIGH</span><span className="text-ellipsis d-block d-md-none">LOW</span></th>
                            <th className="text-end d-none d-md-table-cell" style={{ "width": "10%" }}><span className="text-ellipsis">LOW</span></th> */}
                        </tr>
                    </thead>
                }
            </>

        )
    }

    return (
        <div className="container py-5 container-live-rate">
            {quote && <>
                <h3 className="text-center mb-4">フィリップMT5リアルタイムレート</h3>
                <div className="nav nav-tabs nav-fill mb-0" role="tablist">
                    <button className="nav-link active" id="fx-tab" data-bs-toggle="tab" data-bs-target="#fx" type="button" role="tab" aria-controls="fx" aria-selected="false" tabIndex={-1}>FX</button>
                    <button className="nav-link" id="cfd-tab" data-bs-toggle="tab" data-bs-target="#cfd" type="button" role="tab" aria-controls="cfd" aria-selected="true">株価指数・商品CFD</button>
                </div>
                <div className="tab-content">
                    <div className="tab-pane fade active show" id="fx" role="tabpanel" aria-labelledby="fx-tab" tabIndex={0}>
                        <div className="table-responsive border">
                            <table className="table table-borderless table-striped table-hover table-live-rate mb-0">
                                {renderHeader(SymbolType.FX)}
                                <tbody>
                                    {LIST_FX_SYMBOL.map((symbol, idx) => {
                                        return (
                                            <Symbol key={idx} symbolCd={symbol.split(".")[0]} symbol={symbol} symbolType={SymbolType.FX} />
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="tab-pane fade" id="cfd" role="tabpanel" aria-labelledby="cfd-tab" tabIndex={0}>
                        <div className="table-responsive border">
                            <table className="table table-borderless table-striped table-hover table-live-rate mb-0">
                                {renderHeader(SymbolType.CFD)}
                                <tbody>
                                    {LIST_CFD_SYMBOL.map((symbol, idx) => {
                                        return (
                                            <Symbol key={idx} symbolCd={symbol.split(".")[0]} symbol={symbol} symbolType={SymbolType.CFD} />
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className={`${!isMobile ? "text-end" : ""} mt-1`}>
                        <span style={{ fontSize: "0.9rem" }}>表示のレートは参考値となります。お取引の際は取引画面に表示のレートをご確認ください。</span>
                    </div>
                </div>
            </>}

        </div>
    )
}
export default memo(MarketWatch);